// extracted by mini-css-extract-plugin
export var active = "_83-b";
export var activeIndicator = "_83-6";
export var animate = "_83-a";
export var disabled = "_83-c";
export var flat = "_83-1";
export var fullWidth = "_83-3";
export var lg = "_83-9";
export var md = "_83-8";
export var redoButtonTabGroup = "_83-0";
export var sm = "_83-7";
export var tabButton = "_83-4";
export var tabButtonsContainer = "_83-2";
export var xs = "_83-5";